/** Hosts de rede social — não aceitos no campo "Site da empresa". */
const SOCIAL_HOST_PATTERNS = [
  /^([a-z0-9-]+\.)?instagram\.com$/i,
  /^([a-z0-9-]+\.)?facebook\.com$/i,
  /^([a-z0-9-]+\.)?fb\.com$/i,
  /^([a-z0-9-]+\.)?linkedin\.com$/i,
  /^([a-z0-9-]+\.)?tiktok\.com$/i,
  /^([a-z0-9-]+\.)?youtube\.com$/i,
  /^([a-z0-9-]+\.)?youtu\.be$/i,
  /^([a-z0-9-]+\.)?twitter\.com$/i,
  /^([a-z0-9-]+\.)?x\.com$/i,
];

const GENERIC_SLUG_HOSTS = new Set([
  "instagram",
  "facebook",
  "www",
  "linkedin",
  "tiktok",
  "youtube",
  "twitter",
  "x",
]);

export function normalizeUrlForCheck(raw) {
  const v = String(raw || "").trim();
  if (!v) return null;
  try {
    const withProto = /^https?:\/\//i.test(v) ? v : `https://${v.replace(/^\/\//, "")}`;
    return new URL(withProto);
  } catch {
    return null;
  }
}

export function isSocialProfileHost(hostname) {
  const h = String(hostname || "")
    .toLowerCase()
    .replace(/^www\./, "");
  return SOCIAL_HOST_PATTERNS.some((re) => re.test(h));
}

export function isSocialProfileUrl(raw) {
  const url = normalizeUrlForCheck(raw);
  if (!url) return false;
  return isSocialProfileHost(url.hostname);
}

/** Nome amigável da rede para mensagens (ex.: "Instagram"). */
export function socialNetworkLabel(raw) {
  const url = normalizeUrlForCheck(raw);
  if (!url) return "";
  const h = url.hostname.toLowerCase();
  if (h.includes("instagram")) return "Instagram";
  if (h.includes("facebook") || h.includes("fb.com")) return "Facebook";
  if (h.includes("linkedin")) return "LinkedIn";
  if (h.includes("tiktok")) return "TikTok";
  if (h.includes("youtube") || h.includes("youtu.be")) return "YouTube";
  if (h.includes("twitter") || h === "x.com" || h.endsWith(".x.com")) return "X (Twitter)";
  return "rede social";
}

const SLUG_RE = /^[a-z0-9][a-z0-9_-]{1,31}$/;

/**
 * Sugere slug a partir de perfil social (@empresa), não do nome do host (instagram).
 */
export function deriveSlugFromSocialProfileUrl(raw) {
  const url = normalizeUrlForCheck(raw);
  if (!url || !isSocialProfileHost(url.hostname)) return "";
  const segments = url.pathname.split("/").filter(Boolean);
  const candidate = segments.length ? segments[segments.length - 1] : "";
  if (!candidate || /^\d+$/.test(candidate)) return "";
  let slug = candidate
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "-")
    .replace(/^[-_]+/, "")
    .replace(/[-_]+$/, "");
  if (!SLUG_RE.test(slug) || GENERIC_SLUG_HOSTS.has(slug)) return "";
  if (slug.length > 32) slug = slug.slice(0, 32).replace(/[-_]+$/, "");
  return slug;
}

export function isGenericSlugFromSocialHost(slug) {
  return GENERIC_SLUG_HOSTS.has(String(slug || "").trim().toLowerCase());
}
